// export const CC_CONFIG = {
//   agentId: '', // 应用ID
//   corpId: "2", //企业ID
//   timeStamp: "3", //生成签名的时间戳
//   nonceStr: "4", //生成签名的随机串
//   signature: "5", //签名
//   jsApiList: [
//     "teams.util.getSsoParams"
//     // "biz.util.openLink",
//     // "biz.util.dealWithRead",
//     // "biz.util.openNative",
//     // "ccwork.device.getConfig"
//   ], //  需要注册的jsapi
// };

export const getTuiTuiSSO = (appid) => {
  return new Promise((resolve, reject) => {
    window.cc.ready(function() {
      window.cc.teams.util.getSsoParams({ appid, 
        onSuccess:(res) => {
          resolve(res)
        },
        onFail: () => {
          reject()
        }
      })
    })
  })
}

export const getTuiTuiH5AppParams = () => {
  return new Promise((resolve, reject) => {
    console.log('window.cc',window.cc)
    if (!window.cc) {
      console.error('window.cc 未定义，请确认相关SDK是否已正确加载');
      reject(new Error('window.cc is undefined'));
      return;
    }
    window.cc.ready(function() {
      window.cc.biz.util.onH5AppParams({ 
        onSuccess:(res) => {
          resolve(res)
        },
        onFail: (err) => {
          reject(err)
        }
      })
    })
  })
}

// export const scriptUrl = 'https://im.qihoo.net:8282//fed/web-cdn//js/cc-sdk/1.1.8/cc.min.js'
//线上地址： 'https://im.live.360.cn:8282//fed/web-cdn//js/cc-sdk/1.1.8/cc.min.js'


// WEBPACK FOOTER //
// ./src/config/index.js